import { useSelector, useDispatch } from 'react-redux';
import { switchTenant } from '../store/slices/authSlice';

function MyTenantsPage() {
  const dispatch = useDispatch();
  const tenants = useSelector((state) => state.auth.tenants);
  const activeTenant = useSelector((state) => state.auth.activeTenant);
  const isLoading = useSelector((state) => state.auth.isLoading);

  const handleSwitchTenant = (tenantId) => {
    dispatch(switchTenant(tenantId));
  };

  const getRoleBadgeStyle = (role) => {
    switch (role) {
      case 'admin':
        return 'bg-purple-100 text-purple-700';
      case 'user':
        return 'bg-blue-100 text-blue-700';
      case 'viewer':
        return 'bg-gray-100 text-gray-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">My Tenants</h1>
        <p className="text-sm text-gray-500 mt-1">
          Organizations you belong to. Switch between tenants to access different workspaces.
        </p>
      </div>

      <div className="bg-white shadow rounded-lg overflow-hidden">
        {tenants.length === 0 ? (
          <div className="p-6 text-center text-gray-500">
            You are not a member of any tenants yet.
          </div>
        ) : (
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Tenant
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Role
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {tenants.map((tenant) => {
                const isActive = activeTenant?.tenant_id === tenant.tenant_id;
                return (
                  <tr key={tenant.tenant_id} className={isActive ? 'bg-primary-50' : ''}>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 h-10 w-10 bg-gray-200 rounded-full flex items-center justify-center">
                          <span className="text-gray-600 font-medium text-sm">
                            {tenant.name?.charAt(0)?.toUpperCase() || 'T'}
                          </span>
                        </div>
                        <div className="ml-4">
                          <div className="text-sm font-medium text-gray-900">
                            {tenant.name}
                          </div>
                          <div className="text-sm text-gray-500">
                            {tenant.tenant_id}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-2 py-1 text-xs font-medium rounded-full ${getRoleBadgeStyle(tenant.role)}`}>
                        {tenant.role?.charAt(0)?.toUpperCase() + tenant.role?.slice(1) || 'Unknown'}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {isActive ? (
                        <span className="flex items-center text-green-600">
                          <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                          </svg>
                          Active
                        </span>
                      ) : (
                        <span className="text-gray-400">-</span>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      {isActive ? (
                        <span className="text-gray-400">Current</span>
                      ) : (
                        <button
                          onClick={() => handleSwitchTenant(tenant.tenant_id)}
                          disabled={isLoading}
                          className="text-primary-600 hover:text-primary-900 disabled:opacity-50"
                        >
                          Switch
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default MyTenantsPage;
